import { render, staticRenderFns } from "./AccountChannelSettings.vue?vue&type=template&id=082a34fd&"
import script from "./AccountChannelSettings.vue?vue&type=script&lang=js&"
export * from "./AccountChannelSettings.vue?vue&type=script&lang=js&"
import style0 from "./AccountChannelSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports